interface Options {
  delayMs?: number;
  maxAttempts?: number;
  url: string;
}

export async function waitForFile({ url, maxAttempts = 10, delayMs = 1000 }: Options) {
  for (let i = 0; i < maxAttempts; i += 1) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const response = await fetch(url, { method: "HEAD" });
      if (response.ok) {
        return true;
      }
    } catch (error) {
      if (i === maxAttempts - 1) {
        throw new Error(`File not available after ${maxAttempts} attempts: ${JSON.stringify(error)}`);
      }
    }
    // eslint-disable-next-line no-await-in-loop
    await new Promise(resolve => setTimeout(resolve, delayMs));
  }

  throw new Error("File not available after maximum attempts");
}
